import Image from 'next/image';
import classNames from 'classnames';

export type SearchNoResultsVariant = 'products' | 'vendors';

interface SearchNoResultsProps {
  variant?: SearchNoResultsVariant;
  /** Compact for typeahead / overlay; default for results pages (mobile + desktop). */
  size?: 'default' | 'compact';
  className?: string;
}

const COPY: Record<
  SearchNoResultsVariant,
  { title: string; subtitle: string; image: string; imageAlt: string }
> = {
  products: {
    title: 'محصولی پیدا نشد!',
    subtitle: 'پیشنهاد می‌کنم واژه دیگه‌ای رو جستجو کنی',
    image: '/assets/images/webp/search-empty-state.webp',
    imageAlt: 'نتیجه‌ای برای محصولات پیدا نشد',
  },
  vendors: {
    title: 'فروشگاهی پیدا نشد!',
    subtitle: 'پیشنهاد می‌کنم واژه دیگه‌ای رو جستجو کنی',
    image: '/assets/images/svg/noShops.svg',
    imageAlt: 'نتیجه‌ای برای فروشگاه‌ها پیدا نشد',
  },
};

export default function SearchNoResults({
  variant = 'products',
  size = 'default',
  className,
}: SearchNoResultsProps) {
  const content = COPY[variant];
  const isCompact = size === 'compact';

  return (
    <div
      className={classNames(
        'flex w-full flex-col items-center justify-center text-center',
        isCompact ? 'my-6 px-2' : 'mt-10 mb-6 px-4 md:mt-16 md:mb-10',
        className
      )}
    >
      <Image
        src={content.image}
        alt={content.imageAlt}
        width={isCompact ? 200 : 430}
        height={isCompact ? 170 : 370}
        className={classNames(
          'h-auto w-full object-contain',
          isCompact
            ? 'max-w-[180px] md:max-w-[200px]'
            : 'max-w-[200px] md:max-w-[320px] lg:max-w-[430px]'
        )}
        priority={false}
      />
      <p
        className={classNames(
          'font-bold text-secondary-400',
          isCompact
            ? 'mt-6 text-base md:text-lg'
            : 'mt-8 text-xl md:mt-10 md:text-[28px]'
        )}
      >
        {content.title}
      </p>
      <p className="mt-2 text-xs font-medium text-secondary-300 md:text-sm">
        {content.subtitle}
      </p>
    </div>
  );
}
